import { create } from 'zustand';
import axios from "axios";
const API_BASE_URL = 'https://ucd-point-of-sale-prod-a8414a878924.herokuapp.com';

export const useAuthStore = create((set, get) => ({
    ucdId: '',
    churchId:'',
    churchPassword:'',
    churchName: '',
    userType: null,
    sessionId: null,
    errors: '',
    isAdmin: false,
    weekendSchedulingDisabled: false,

    loginUser: async (values) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/churches/schedulerlogin`, {
                ucdId: values.ucdId,
                password: values.password,
            });

            const data = response.data;

            if(data.success === true) {
                set({
                    ucdId: values.ucdId,
                    churchPassword: values.password,
                    userType: data.userType,
                    churchId: data._id,
                    churchName: data.churchName,
                    errors: '',
                    weekendSchedulingDisabled: data.disableWeekendsOnly,
                    isAdmin: data.userType === 'church-admin'
                });
                return response.data;
            } else {
                set({
                    errors: 'Incorrect username or password.',
                })
            }
        } catch (error) {
            set({
                errors: 'Incorrect username or password.',
            })
        }
    },

    logoutUser: () => {
        set({
            ucdId: '',
            churchId:'',
            churchPassword:'',
            churchName: '',
            userType: null,
            sessionId: null,
            errors: '',
            isAdmin: false,
        })
    },

    toggleWeekendScheduling: async (isAdmin, payload) => {
        try {
            set({ loading: true, error: null });

            const endpoint = `${API_BASE_URL}/churches/changeweekendscheduling`;
            const response = await axios.put(endpoint, payload);

            if (response.status === 200) {
                set({
                    weekendSchedulingDisabled: payload.disable_weekend_scheduling,
                    loading: false
                });
                return true;
            }
        } catch (error) {
            const errorMessage = error.response?.status === 403
                ? "You are not permitted to perform this action"
                : error.response?.status === 404
                    ? "Church Not Found"
                    : "Error updating weekend scheduling";

            set({ error: errorMessage, loading: false });
            return false;
        }
    },

}));